import { LoginLock } from "assets/images";
import fingerPrintPrompt from "FingerPrintAuth";
import { FC } from "react";
import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import { ToastDanger } from "utils/toast/Toast";
const ChooseLogTypePc: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const optionsType = [{ name: "", icon: LoginLock, key: 1, url: "" }];
  const handleGetTouch = async () => {
    const check =
      await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();

    if (check) {
      const result = await fingerPrintPrompt();
      if (result) {
        const now = new Date();

        if (localStorage.getItem("touchLogin")) {
          localStorage.removeItem("touchLogin");
          window.location.reload();
        } else {
          localStorage.setItem("touchLogin", now.toISOString());
          window.location.reload();
        }
      } else {
        ToastDanger("مشکلی پیش آمده.");
      }
    } else {
      ToastDanger("دستگاه شما از این قابلیت پشتیبانی نمیکند");
    }
  };

  return (
    <OverlayModalCommon onClose={onClose} open={open}>
      <div className="contentModalSettingsMapPc scrollbar-div">
        <div className="rowheaderModalSettingMap">
          <div onClick={onClose} className="icon3-close pointer" />
          <div className="titleheaderModal">روش ورودی</div>
        </div>

        <div className="rowbodyModalLogType">
          {optionsType.map((op) => (
            <div
              onClick={handleGetTouch}
              key={op.key}
              className="containerLogType pointer"
            >
              <img src={op.icon} alt="icon" className="contentLogTypeImg" />
              <div className="titleLogType">
                {localStorage.getItem("touchLogin")
                  ? "غیر فعال کردن"
                  : "فعال کردن"}
              </div>
            </div>
          ))}
        </div>

        <div className="rowBtnSettingsMap">
          <div onClick={onClose} className="BtnLgoTypeCancel">
            انصراف
          </div>
        </div>
      </div>
    </OverlayModalCommon>
  );
};
export default ChooseLogTypePc;
